import React, { useState, useEffect } from 'react';
import { TRANSLATIONS } from '../../../translations';

const MegaSelect = ({
  inputName,
  options,
  register,
  onChange,
  multiple = false,
  error,
  setError,
}) => {
  const [value, setValue] = useState(multiple ? [] : null);

  function reorderByRecommendation(obj) {
    return Object.fromEntries(
      Object.entries(obj).sort(([, a], [, b]) => {
        return (b.recommended === true) - (a.recommended === true);
      })
    );
  }
  const orderedOptions = reorderByRecommendation(options);

  useEffect(() => {
    if (onChange) {
      onChange(value);
    }
  }, [value]);

  const handleSelect = (optionValue) => {
    if (multiple) {
      setValue((prev) =>
        prev.includes(optionValue)
          ? prev.filter((val) => val !== optionValue)
          : [...prev, optionValue]
      );
    } else {
      setValue(optionValue);
    }

    if (setError) setError(null);
  };

  return (
    <div className="mega-select gap-xs">
      {error && (
        <p className="typography__error mb-2xs">
          <small className="error-message">
            <b>{error}</b>
          </small>
        </p>
      )}
      {Object.entries(orderedOptions).map(([optionValue, optionData]) => {
        const title =
          typeof optionData === 'object' ? optionData.title : optionData;
        const description = optionData.description
          ? optionData.description
          : null;
        const icon = optionData.icon ? optionData.icon : null;
        const recommended = optionData.recommended !== undefined ? true : false;

        return (
          <div
            key={optionValue}
            className={`mega-select__option mega-select__option${
              value && value.includes(optionValue) ? '--selected' : '--empty'
            } ${error ? 'mega-select__option--error' : ''}`}
            onClick={() => handleSelect(optionValue)}
          >
            {recommended && (
              <div className="mega-select__option__recommended">
                {TRANSLATIONS.RECOMMENDED_OPTION}
              </div>
            )}
            <div>{icon && icon}</div>

            <div className="d-flex flex-column">
              <div className="mega-select__option__title">{title}</div>
              {description && (
                <div
                  className="mega-select__option__description"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
            </div>

            <input
              hidden
              type="checkbox"
              name={inputName}
              value={optionValue}
              ref={register}
              checked={
                multiple
                  ? value && value.includes(optionValue)
                  : value === optionValue
              }
              onChange={() => handleSelect(optionValue)}
              className="hidden-checkbox"
            />
          </div>
        );
      })}
    </div>
  );
};

export { MegaSelect };
